import React from "react";
import ModalPortal from "./ModalPortal";
import BaseModalContainer from "./BaseModalContainer";
import styled from "styled-components";
import { Button, Typography15, Typography20 } from "@slid/slid-ips";
import { useTranslation } from "react-i18next";
import { isAndroid } from "react-device-detect";
import environments from "config/env";

const IPadAppTerminationModal = () => {
  const { t } = useTranslation("Modal");

  return (
    <ModalPortal target={"body"}>
      <BaseModalContainer callback={() => {}} closable={false}>
        <ModalContainer>
          <Typography20 text={t("IPadAppTerminationModal.title", { keySeparator: "." })} color={"--gray18"} weight={700} textAlign="center" />
          <Typography15 text={t("IPadAppTerminationModal.description", { keySeparator: "." })} color={"--gray18"} marginTop="8px" textAlign="center" />
          <ButtonWrapper>
            <Button
              text={t("IPadAppTerminationModal.primaryButton", { keySeparator: "." })}
              callback={() => {
                if (isAndroid) {
                  window.open(environments.links.slid_new_mobile_android, "_blank");
                } else {
                  //@ts-ignore
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                      type: "WEB_TO_APP_openURL",
                      payload: environments.links.slid_new_mobile_ios,
                    })
                  );
                }
              }}
              appearance="primary"
              size="medium"
            />
          </ButtonWrapper>
        </ModalContainer>
      </BaseModalContainer>
    </ModalPortal>
  );
};

const ModalContainer = styled.div`
  z-index: 9999999;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  padding: 28px 20px 16px;
  box-shadow: var(--boxShadow1);
  width: 312px;
`;

const EmojiContainer = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
  font-size: 42px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 28px;
  gap: 8px;
  width: 100%;

  && * {
    flex: 1;
  }
`;

export default IPadAppTerminationModal;
